import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'

import { fetchAPI } from '@/lib/api'
import { getErrorMsg, t } from '@/lib/helpers'

import { Post, PostApprovalFormInput } from '../types'
import { POSTS } from '../constants'

type PostsListCache = {
  data: Post[]
  meta: unknown
}

const updatePostApproval = async (data: PostApprovalFormInput) => {
  await fetchAPI({
    method: 'put',
    path: `/posts/${data.id}/approve`,
    data: {
      approve_image_ids: data.approve_image_ids,
    },
  })
}

export const useUpdatePostApproval = () => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation(updatePostApproval, {
    onSuccess: (_result, variables) => {
      queryClient.setQueriesData<PostsListCache | undefined>(
        [POSTS],
        (old) => {
          if (!old) return old
          return {
            ...old,
            data: old.data.map((post) =>
              post.id === variables.id ? { ...post, approved: true } : post,
            ),
          }
        },
      )

      void queryClient.refetchQueries([POSTS])

      toast({
        description: t('views.admin.posts.services.update_success'),
        status: 'success',
        position: 'top-right',
        isClosable: true,
      })
    },
    onError(error) {
      toast({
        description: getErrorMsg(error),
        status: 'error',
        position: 'top-right',
        variant: 'left-accent',
        isClosable: true,
      })
    },
  })
}
